import axios from 'axios';
import logComponent from '../logComponent';
import getConfig from './getConfig';

const MonitoredIndividual = (function () {
  function Id(monitoredIndividualId, eager) {
    if (logComponent('MonitoredIndividual')) { console.debug('MonitoredIndividual Id'); }
    let params = { eager };

    return axios.get(`api/MonitoredIndividual/${monitoredIndividualId}`, getConfig(params));
  }
  function GetSummaryForPastDays(monitoredIndividualId, pastNumberOfDays) {
    if (logComponent('MonitoredIndividual')) { console.debug('MonitoredIndividual GetSummaryForPastDays'); }
    let params = { monitoredIndividualId, pastNumberOfDays };
    return axios.get(`api/MonitoredIndividual/GetSummaryForPastDays`, getConfig(params));
  }
  return {
    Id,
    GetSummaryForPastDays
  }
})();

export default MonitoredIndividual;